import React from "react";
import Slider from "rc-slider";
import { UncontrolledTooltip, Tooltip } from "reactstrap";
import { getDeep } from "../components/Utils";
import PropTypes from "prop-types";

class MeasurementSlider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value !== undefined ? this.props.value : 0,
      sliderDescription: this.props.textDescriptions[this.props.value],
      tooltipOpen: false
    };
  }

  tooltipToggle = () => {
    this.setState({
      tooltipOpen: true
    });
  };

  updateValue = (value) => {
    this.setState({
      value,
      sliderDescription: this.props.textDescriptions[value]
    });

    if (this.props.uuid !== undefined) {
      this.props.updateMeasurement(this.props.params.eventId, this.props.student.uuid, this.props.uuid, value);
    }
    if (this.props.callbackParent) {
      this.props.callbackParent(value);
    }

    if (this.props.linkedMeasurements !== undefined) {
      this.props.linkedMeasurements.forEach((linkedMeasurement) => {
        this.props.updateMeasurement(this.props.params.eventId, this.props.student.uuid, linkedMeasurement, value);
      });
    }
  };

  render() {
    let indentedClass = this.props.indented === true ? "indented" : "";

    let tooltipItem = null;
    if (this.props.description !== undefined && this.props.description.length > 3) {
      tooltipItem = (
        <div>
          <span className="show-tooltip" role="menuitem" id={"tooltiptrigger" + this.props.uuid}>
            <i className="fa fa-info"></i>
          </span>
          <UncontrolledTooltip role="menuitem" placement="left" target={"tooltiptrigger" + this.props.uuid} className="measurement-tooltip">
            {this.props.description}
          </UncontrolledTooltip>
        </div>
      );
    }

    let defaultValue = this.state.value;
    let sliderDescription = this.state.sliderDescription;
    if (getDeep(this.props.measurements, [this.props.params.eventId], [this.props.student.uuid], [this.props.uuid]) !== undefined) {
      defaultValue = getDeep(this.props.measurements, [this.props.params.eventId], [this.props.student.uuid], [this.props.uuid]);
      sliderDescription = this.props.textDescriptions[defaultValue];
    }

    return (
      <div className={"measurement-slider-wrapper " + indentedClass}>
        <div className="measurement-bundle-title">
          {tooltipItem}
          {this.props.title}
        </div>

        {this.props.hideSlider ? (
          false
        ) : (
          <div className="measurement-slider">
            <Slider
              min={0}
              max={4}
              marks={{
                0: "",
                1: "O",
                2: "VVV",
                3: "V",
                4: "G"
              }}
              disabled={this.props.readonly || false}
              value={defaultValue}
              onChange={this.updateValue}
              onAfterChange={this.updateValue}
            />

            <div className="slider-description">{sliderDescription}</div>
          </div>
        )}
      </div>
    );
  }
}

MeasurementSlider.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.number,
  textDescriptions: PropTypes.array,
  indented: PropTypes.bool
};

MeasurementSlider.defaultProps = {
  description: "",
  textDescriptions: [
    <div>&nbsp;</div>,
    <div className="text-danger">
      <strong>Onvoldoende</strong>
    </div>,
    <div className="text-warning">
      <strong>Voor verbetering vatbaar</strong>
    </div>,
    <div className="text-success">
      <strong>Voldoende</strong>
    </div>,
    <div className="text-success">
      <strong>Goed</strong>
    </div>
  ]
};

module.exports = MeasurementSlider;



// WEBPACK FOOTER //
// ./components/MeasurementSlider.js